import * as yup from "yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import FormField from "@src/components/FormField/FormField";
import Input from "@src/components/Input/Input";
import "../styles/form.sass";
import { NotificationPreference, NotificationType } from "@src/types/global";

interface IProps {
    submitFormFn: (data: FormValues) => void;
    userPreferences: NotificationPreference[];
    notificationTypes: NotificationType[];
}
type NotificationPreferenceForm = NotificationPreference & { status: boolean };

type FormValues = {
    notification_preferences: NotificationPreferenceForm[];
};

const schema = yup
    .object()
    .shape({ notification_preferences: yup.array().required() });

const UserNotificationsForm = ({
    submitFormFn,
    userPreferences,
    notificationTypes,
}: IProps) => {
    /*
     * If userPreferences (up) contain the id of a notificationType (nt),
     * we set the nt.status = up.status
     */
    function assignDefaultValues(): {
        notification_preferences: NotificationPreferenceForm[];
    } {
        const defaultValues: NotificationPreferenceForm[] = [];
        userPreferences.forEach((up) => {
            const setValue = notificationTypes?.find(
                (np) => np.id == up.notification_type_id,
            );
            if (setValue) {
                defaultValues.push({
                    ...setValue,
                    status: up.status,
                    notification_type_id: up.notification_type_id,
                });
            }
        });
        return { notification_preferences: defaultValues };
    }

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<FormValues>({
        defaultValues: assignDefaultValues(),
        resolver: yupResolver(schema),
    });
    /**
     * Transforms the data for submission
     * @param data
     */
    const onSubmit: SubmitHandler<FormValues> = (data) => {
        submitFormFn(data);
    };
    // Submits the form on change (when a box is checked)
    useEffect(() => {
        const subscription = watch(() => handleSubmit(onSubmit)());
        return () => subscription.unsubscribe();
    }, [handleSubmit, watch]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {notificationTypes.map((notificationType, index) => (
                <div key={notificationType.id}>
                    <Input
                        type="hidden"
                        name={`notification_preferences[${index}].id`}
                        register={register}
                    />
                    <Input
                        type="hidden"
                        name={`notification_preferences[${index}].notification_type_id`}
                        register={register}
                        value={notificationType.id}
                    />
                    <FormField
                        name={`notification_preferences[${index}].status`}
                        hideLabel={true}
                        errors={errors}
                    >
                        <Input
                            type="checkbox"
                            label={notificationType.description}
                            name={`notification_preferences[${index}].status`}
                            register={register}
                        />
                    </FormField>
                </div>
            ))}
        </form>
    );
};
export default UserNotificationsForm;
